import Phaser from 'phaser';

const splashUrl = new URL('../../images/cool-ez-retro-games-splash.png', import.meta.url).toString();

export class SplashScene extends Phaser.Scene {
  constructor() {
    super({ key: 'SplashScene' });
  }

  preload(): void {
    this.load.image('homeSplash', splashUrl);
  }

  create(): void {
    const splash = this.add.image(0, 0, 'homeSplash');
    const playNowZone = this.add.zone(0, 0, 1, 1);
    const playNowOutline = this.add.rectangle(0, 0, 1, 1, 0x00ffff, 0)
      .setStrokeStyle(3, 0xffff00, 0.9)
      .setVisible(false);
    const leftFade = this.add.graphics().setDepth(1);
    const rightFade = this.add.graphics().setDepth(1);
    const playNowOffsetY = 0.34;
    const playNowWidth = 0.3;
    const playNowHeight = 0.1;
    const playNowOffsetPx = 50;
    const edgeFadeWidthRatio = 0.12;
    const edgeFadeAlpha = 0.85;
    const creditText = 'by \u00A9Affordable Web Designs';
    const creditLabel = this.add.text(0, 0, creditText, {
      fontFamily: 'Arial Black',
      fontSize: '10px',
      color: '#ff3333',
    }).setOrigin(0.5).setVisible(false).setDepth(51);

    playNowZone.setInteractive({ useHandCursor: true });
    playNowZone.on('pointerdown', () => {
      this.scene.start('HomeScene');
    });

    const hoverTween = this.tweens.add({
      targets: playNowOutline,
      scale: { from: 1, to: 1.04 },
      alpha: { from: 0.6, to: 1 },
      duration: 500,
      yoyo: true,
      repeat: -1,
      paused: true,
    });

    playNowZone.on('pointerover', () => {
      playNowOutline.setVisible(true);
      hoverTween.play();
    });

    playNowZone.on('pointerout', () => {
      hoverTween.stop();
      playNowOutline.setVisible(false);
      playNowOutline.setScale(1);
      playNowOutline.setAlpha(1);
    });

    const layoutSplash = (width: number, height: number) => {
      const scale = Math.min(width / splash.width, height / splash.height);
      splash.setScale(scale);
      splash.setPosition(width / 2, height / 2);

      const splashLeft = splash.x - splash.displayWidth / 2;
      const splashTop = splash.y - splash.displayHeight / 2;
      const fadeWidth = splash.displayWidth * edgeFadeWidthRatio;
      const fadeHeight = splash.displayHeight;

      playNowZone.setPosition(
        splash.x,
        splash.y + splash.displayHeight * playNowOffsetY + playNowOffsetPx
      );
      playNowZone.setSize(splash.displayWidth * playNowWidth, splash.displayHeight * playNowHeight);
      playNowOutline.setPosition(playNowZone.x, playNowZone.y);
      playNowOutline.setDisplaySize(playNowZone.width, playNowZone.height);
      const creditX = splash.x - splash.displayWidth * 0.18 - 35;
      const creditY = splash.y + splash.displayHeight * 0.37 - 5;
      creditLabel.setPosition(creditX, creditY);
      creditLabel.setVisible(true);

      leftFade.clear();
      leftFade.fillGradientStyle(
        0x000000,
        0x000000,
        0x000000,
        0x000000,
        edgeFadeAlpha,
        0,
        edgeFadeAlpha,
        0
      );
      leftFade.fillRect(splashLeft, splashTop, fadeWidth, fadeHeight);

      rightFade.clear();
      rightFade.fillGradientStyle(
        0x000000,
        0x000000,
        0x000000,
        0x000000,
        0,
        edgeFadeAlpha,
        0,
        edgeFadeAlpha
      );
      rightFade.fillRect(splashLeft + splash.displayWidth - fadeWidth, splashTop, fadeWidth, fadeHeight);
    };

    layoutSplash(this.scale.width, this.scale.height);
    this.scale.on('resize', (gameSize: Phaser.Structs.Size) => {
      layoutSplash(gameSize.width, gameSize.height);
    });

    this.tweens.add({
      targets: creditLabel,
      alpha: { from: 0.5, to: 1 },
      duration: 1400,
      yoyo: true,
      repeat: -1,
    });

    creditLabel.setInteractive({ useHandCursor: true });
    creditLabel.on('pointerdown', () => {
      window.open('https://www.affordablewebdesigns.co', '_blank', 'noopener');
    });
    creditLabel.on('pointerover', () => {
      creditLabel.setColor('#ff6666');
    });
    creditLabel.on('pointerout', () => {
      creditLabel.setColor('#ff3333');
    });
  }
}
